const comments = [
  {
    id: 1,
    name: "吃瓜一线群众",
    time: "2 小时前",
    content: "这个顶流的料我蹲了三个月了，终于有人完整整理出来了！细节全对上了，我当时就在现场，只能说比写的还精彩。",
    likes: 2837,
  },
  {
    id: 2,
    name: "圈内老炮儿",
    time: "5 小时前",
    content: "干了十年娱记，爆料专区的深扒质量确实可以。很多料我们内部都知道但不敢发，这里敢说真话，respect。",
    likes: 1952,
  },
  {
    id: 3,
    name: "理性吃瓜不站队",
    time: "8 小时前",
    content: "之前那个带货主播翻车的系列我全程追完，逻辑清晰证据链完整，比那些只会标题党的号强太多了。",
    likes: 1548,
  },
  {
    id: 4,
    name: "深夜潜水党",
    time: "12 小时前",
    content: "每晚睡前必刷爆料专区，已经成为习惯了。最近那个综艺选秀黑幕的连载什么时候更新啊？等得我好苦。",
    likes: 3215,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 text-center mb-4">
          读者热议
        </h2>
        <div className="w-16 h-1 bg-primary-500 mx-auto mb-10 rounded-full"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((c) => (
            <div
              key={c.id}
              className="bg-background-50 rounded-lg p-5 border border-background-200/50"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-400 text-sm font-semibold">
                    {c.name.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-foreground-200 text-sm font-medium truncate">{c.name}</p>
                  <p className="text-foreground-600 text-xs">{c.time}</p>
                </div>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">{c.content}</p>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/40">
                <button className="flex items-center gap-1.5 text-foreground-500 hover:text-primary-400 text-xs transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{c.likes.toLocaleString()}</span>
                </button>
                <button className="flex items-center gap-1.5 text-foreground-500 hover:text-foreground-300 text-xs transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}